"use client";
import React from "react";
import type { FooterProps } from "@/components/footers";
import { getBackgroundStyle } from "@/lib/background";

export default function FooterBasic({ data }: FooterProps) {
  const { logo, bottom = {}, background = {} } = data || {};

  const bgStyle = getBackgroundStyle(background);

  return (
    <footer className="py-6 text-sm text-muted-foreground" style={bgStyle}>
      <div className="max-w-6xl mx-auto px-4 flex flex-col sm:flex-row justify-between items-center gap-4">
        {logo?.src && (
          <a href={logo.href || "/"} className="flex items-center gap-2">
            <img
              src={logo.src}
              alt={logo.alt || "Logo"}
              className="h-6"
              loading="lazy"
            />
          </a>
        )}

        <div className="text-center sm:text-right">
          <p>
            {bottom?.text ||
              `© ${new Date().getFullYear()} All rights reserved.`}
          </p>
          {Array.isArray(bottom?.links) && bottom.links?.length > 0 && (
            <div className="flex gap-4 justify-center sm:justify-end mt-1">
              {bottom.links?.map((link, idx) => (
                <a
                  key={idx}
                  href={link.href}
                  className="hover:text-primary transition"
                  aria-label={link.label}
                >
                  {link.label}
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </footer>
  );
}
